// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"833298e7","203":"9565217c","229":"51c606df","231":"8ed81351","350":"c91af5ef","526":"b2159beb","533":"996bde4a","550":"b7715a81"}[chunkId] + ".chunk.js";
};